import React from 'react';
import { SectionHeading } from './SectionHeading';
import { costRows } from '../data/salesData';
export function CostSection() {
  return <section className="border-b border-[var(--olive)]/30 py-16 sm:py-20" data-id="element-28" data-mp="9e13iq02gbwk">
      <div className="mx-auto max-w-4xl px-4" data-id="element-29" data-mp="4jwtfxvi7nr9">
        <SectionHeading eyebrow="⚖️ La cuenta que nadie hace" data-id="element-30" data-mp="3vrix3qi83q84">
          ¿Cuánto cuesta no tenerlo?
        </SectionHeading>

        <div className="sales-scrollbar mt-8 overflow-x-scroll pb-3" data-id="element-31" data-mp="3qsoccj0p3rld">
          <table className="w-full min-w-[620px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--olive)]/40 text-left text-sm" data-id="element-32" data-mp="3mqugco1g3brj">
            <thead data-id="element-33" data-mp="3hrzz3qj4lv9j">
              <tr className="bg-[#12140b]" data-id="element-34" data-mp="3htkt9f1j3c6v">
                <th className="p-4 font-semibold text-red-400" data-id="element-35" data-mp="3ctg7palrjr9s">
                  Sin Super Kit
                </th>
                <th className="p-4 font-semibold text-[var(--gold-light)]" data-id="element-36" data-mp="1fz235lu1ymkd">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-37" data-mp="p71xtoad9xdj">
              {costRows.map((row, i) => <tr key={row.without} className={i % 2 === 0 ? 'bg-[#0d0f08]' : 'bg-[#0a0b06]'} data-id="element-38" data-mp="p9o5dnx9ccvr" data-mpi={i}>
                  <td className="border-t border-white/5 p-4 font-medium text-[var(--cream)]" data-id="element-39" data-mp="fa6wkxmplivk">
                    {row.without}
                  </td>
                  <td className="border-t border-white/5 p-4 text-white/75" data-id="element-40" data-mp="kabhr0ykb1s4">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="mt-10 text-center font-serif-display text-2xl font-semibold text-[var(--gold-light)] sm:text-3xl" data-id="element-41" data-mp="y8jaewokfgxh">
          El próximo lunes puede ser diferente.
        </p>
      </div>
    </section>;
}